var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"first-screen"},[_c('h1',{staticClass:"app-name"},[_vm._v(_vm._s(_vm.$t(_vm.app_name)))]),_c('div',{staticClass:"button-box"},[_c('download-button')],1),_c('div',{staticClass:"swiper"},[_c('my-swiper')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }